export default __webpack_public_path__ + "static/media/SOUVENIRS.26456a7e.jpg";